import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-xl font-bold mb-3">{title}</h2>
    <div className="text-sm text-muted-foreground leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="pt-32 pb-24 px-6">
        <div className="max-w-3xl mx-auto">
          <span className="text-xs font-semibold tracking-widest uppercase text-primary">Vos données</span>
          <h1 className="font-display text-4xl font-extrabold mt-3 mb-2">Politique de confidentialité</h1>
          <p className="text-sm text-muted-foreground mb-10">Dernière mise à jour : juin 2026 · Monaga Adflow (MONASAR)</p>

          <Section title="1. Responsable du traitement">
            <p>Le responsable du traitement des données est MONASAR, éditeur de la marque Monaga Adflow, situé au 127 Chemin de Saint-Joseph, Sainte-Marthe, 13014 Marseille, France. Contact : jamdiam33@gmail.com.</p>
          </Section>

          <Section title="2. Données que nous collectons">
            <p>Nous collectons : vos informations de compte (nom, e-mail, mot de passe chiffré ou identifiant Google), les données de votre marque (secteur, objectifs, catalogue produits), les contenus que vous générez (visuels, textes, vidéos), les données d'usage et de facturation.</p>
          </Section>

          <Section title="3. Utilisation des données">
            <p>Vos données servent à : fournir et améliorer le service de création et de diffusion publicitaire, générer vos contenus par IA, gérer votre abonnement et vos crédits, assurer la sécurité du compte et vous fournir une assistance.</p>
          </Section>

          <Section title="4. Partage des données">
            <p>Nous ne vendons jamais vos données. Elles peuvent être transmises à nos sous-traitants techniques strictement nécessaires : prestataires d'IA (génération de visuels et textes), Stripe (paiements sécurisés), et notre hébergeur. Chacun est tenu à la confidentialité.</p>
          </Section>

          <Section title="5. Paiements">
            <p>Les paiements sont traités par Stripe. Nous ne stockons aucune donnée de carte bancaire sur nos serveurs.</p>
          </Section>

          <Section title="6. Conservation">
            <p>Vos données sont conservées pendant la durée de votre compte, puis supprimées ou anonymisées dans un délai raisonnable après sa clôture, sauf obligation légale de conservation (ex. factures).</p>
          </Section>

          <Section title="7. Vos droits (RGPD)">
            <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et d'opposition sur vos données. Pour exercer ces droits, écrivez-nous à jamdiam33@gmail.com. Vous pouvez également saisir la CNIL.</p>
          </Section>

          <Section title="8. Sécurité">
            <p>Vos données sont chiffrées en transit et au repos. L'accès est strictement contrôlé et un journal d'activités trace les actions sensibles sur votre compte.</p>
          </Section>

          <Section title="9. Cookies">
            <p>Nous utilisons uniquement des cookies strictement nécessaires au fonctionnement du service (authentification, préférences d'affichage). Aucun cookie publicitaire tiers n'est déposé sans votre consentement.</p>
          </Section>

          <Section title="10. Contact">
            <p>Pour toute question relative à cette politique, contactez-nous à jamdiam33@gmail.com.</p>
          </Section>
        </div>
      </section>
      <Footer />
    </div>
  );
}
